import { observer } from "mobx-react-lite";
import { FC, FormEvent, useState } from "react";
import { AuthCardBase } from "@/components/auth/AuthCardBase";
import { MDSButton, MDSButtonVariant, MDSTextField, MDSTextFieldVariant } from "@/mds";
import { usePublicAppStore } from "@/store";
import styled from "@emotion/styled";

export interface AuthCardLogInProps {}

export const AuthCardOAuthToken: FC<AuthCardLogInProps> = observer(() => {
  const { publicStore } = usePublicAppStore();

  const [accountId, setAccountId] = useState<string>("");
  const [oauthToken, setOauthToken] = useState<string>("");

  const handleLogin = async (e: FormEvent) => {
    e.preventDefault;
    await publicStore.auth.authenticateAccountUsingOAuthToken({ accountId, oauthToken });
  };

  const isLoading = publicStore.auth.authenticateAccountUsingOAuthTokenState.isLoading;

  return (
    <AuthCardBase>
      <AuthForm>
        <MDSTextField
          variant={MDSTextFieldVariant.Form}
          type="text"
          placeholder="Account ID"
          value={accountId}
          onChange={value => setAccountId(value)}
          isDisabled={isLoading}
          autoFocus
        />
        <MDSTextField
          variant={MDSTextFieldVariant.Form}
          type="text"
          placeholder="OAuth Token"
          value={oauthToken}
          onChange={value => setOauthToken(value)}
          isDisabled={isLoading}
        />
        <MDSButton variant={MDSButtonVariant.Contrast} isLoading={isLoading} onClick={handleLogin}>
          Login
        </MDSButton>
      </AuthForm>
    </AuthCardBase>
  );
});

const AuthForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing[4]};
  width: 100%;

  // Targets MDSTextField container
  > div {
    width: 100%;
  }
`;
